import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import DashboardSectionCustomComponents1 from '../components/custom-components/DashboardSectionCustomComponents1';

const meta = {
  title: 'Dashboard - Ordio.io',
  meta: [],
  link: [],
  style: [],
  script: [
    {
      src: 'js/653114.js?v=1753853553',
    },
    {
      src: 'js/global-2274.js',
    },
  ],
};

export default function Dashboard() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <DashboardSectionCustomComponents1 />
    </React.Fragment>
  );
}

